import { render, staticRenderFns } from "./EventsCalendarOverlay.vue?vue&type=template&id=62c871fc&scoped=true&"
import script from "./EventsCalendarOverlay.vue?vue&type=script&lang=ts&"
export * from "./EventsCalendarOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c871fc",
  null
  
)

export default component.exports